/**
 * @title 小票打印
 * */
import Vue from 'vue';
import PrintReceipt from './index.vue';
import debounce from 'lodash/debounce';

const PrintImageFactory = Vue.extend(PrintReceipt);

let instance = null;

/**
 * @param {String | Array} source
 * */
const printReceipt = debounce(
  source => {
    if (!instance) {
      instance = new PrintImageFactory();
      instance.vm = instance.$mount();
      document.body.appendChild(instance.vm.$el);
    }
    instance.init(source);
  },
  300,
  { trailing: false, leading: true }
);

export default printReceipt;
